import { render, staticRenderFns } from "./portfolioexcelview.vue?vue&type=template&id=3babc334&scoped=true&"
import script from "./portfolioexcelview.vue?vue&type=script&lang=js&"
export * from "./portfolioexcelview.vue?vue&type=script&lang=js&"
import style0 from "./portfolioexcelview.vue?vue&type=style&index=0&id=3babc334&lang=scss&scoped=true&"
import style1 from "./portfolioexcelview.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3babc334",
  null
  
)

export default component.exports